module.exports = __webpack_public_path__ + "img/huace15.8bde7a96.jpg";